import PhoneInTalkIcon from '@cp/src/assets/icons/PhoneInTalkIcon';
import Chip from '@navi/web-ui/lib/primitives/Chip/Chip';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import cx from 'classnames';
import { ICorporateNoCardProps } from '../../interfaces/types';
import SimCardIcon from '@cp/src/assets/icons/SimCardIcon';
import { NUMBER_STATUS } from '../../constants/constants';
import { DateFormat, dateFormat, getFormatDate } from '@cp/src/utils/DateHelper';
import dayjs from 'dayjs';

const CorporateNoCard = (props: ICorporateNoCardProps) => {
  const { corporateNo } = props;
  const isActiveNumber = corporateNo.status === NUMBER_STATUS.ACTIVE;
  const isRecordingOn = corporateNo.recordingPlan;
  const activeFrom = getFormatDate(Number(corporateNo.createdAt), DateFormat.DD_MMM_YYYY_HH_MM);
  const activeTill = corporateNo.lastModifiedAt
    ? getFormatDate(Number(corporateNo.lastModifiedAt), DateFormat.DD_MMM_YYYY_HH_MM)
    : '';
  return (
    <div className="flex flex-col items-start gap-2">
      <Typography variant="p3" color="var(--grayscale-2)">
        {corporateNo.corporatePhoneNumber}
      </Typography>
      <div className="flex justify-start items-center space-x-2">
        <Chip
          label={`Sim : ${isActiveNumber ? 'Active' : 'Inactive'}`}
          LeftAdornment={
            <SimCardIcon fillColor={isActiveNumber ? 'var(--green-base)' : 'var(--red-base)'} />
          }
          labelClasses={cx(
            'pr-1 text-xs font-medium',
            { 'text-[var(--green-base)]': isActiveNumber },
            { 'text-[var(--red-base)]': !isActiveNumber }
          )}
          wrapperClasses={cx(
            'border border-solid rounded border-[var(--green-light-3)] bg-[var(--green-light)] px-1 py-1',
            { 'border-[var(--green-light-3)] bg-[var(--green-light)]': isActiveNumber },
            { 'border-[var(--red-light-1)] bg-[var(--red-light-1)]': !isActiveNumber }
          )}
        />

        <Chip
          label={`Recording : ${isRecordingOn ? 'On' : 'Off'}`}
          LeftAdornment={
            <PhoneInTalkIcon fillColor={isRecordingOn ? 'var(--green-base)' : 'var(--red-base)'} />
          }
          labelClasses={cx(
            'pr-1 text-xs font-medium',
            { 'text-[var(--green-base)]': isRecordingOn },
            { 'text-[var(--red-base)]': !isRecordingOn }
          )}
          wrapperClasses={cx(
            'border border-solid rounded border-[var(--green-light-3)] bg-[var(--green-light)] px-1 py-1',
            { 'border-[var(--green-light-3)] bg-[var(--green-light)]': isRecordingOn },
            { 'border-[var(--red-light-1)] bg-[var(--red-light-1)]': !isRecordingOn }
          )}
        />
      </div>

      <Typography variant="p5" color="var(--grayscale-3)">
        Active from {activeFrom} {activeTill && !isActiveNumber && `to ${activeTill}`}
      </Typography>
    </div>
  );
};

export default CorporateNoCard;
